<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Installment Fees Due Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center" align="center" class="no-display">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="current_academic_year" :items="academic_year_list"
                        item-text="ay" return-object label="Academic Year" outlined persistent-hint
                        hint="Please Select Academic Year"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="section" :items="section_list" item-text="name"
                        item-value="id" label="Section" outlined @change="getStandard();" persistent-hint
                        hint="Please Select Section"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="std" item-value="id" multiple :items="standard_list"
                        item-text="standard" label="Standard" outlined @change="
                            clear();
                        " persistent-hint hint="Please Select Standard"></v-autocomplete>
                </v-col>
                <v-col sm="2" v-if="this.std.length > 0">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="div" multiple :items="dision_list"
                        item-text="division" item-value="id" label="Division" outlined
                        @change="clear()"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" @change="clear()"
                        :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint
                        hint="Select Status" />
                </v-col>
            </v-row>
            <v-row align="center" justify="center">
                <v-col cols="12" md="3" sm="3">
                    <v-checkbox v-model="show_balance_fee_student" class="mb-0"
                        label="Show only students with remaining fees"></v-checkbox>
                </v-col>
                <v-col cols="12" md="2" sm="2" style="align-items: center;">
                    <v-checkbox
                        v-model="show_date_wise"
                        @change="toggleDateFilter"
                        label="Fetch Date Wise Report"
                    ></v-checkbox>
                </v-col>
                <v-col cols="12" md="2" sm="2" v-if="show_date_wise">
                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense v-model="new_from_date" @blur="if(new_from_date){ date1 = parseDate(new_from_date) }"
                                v-on="on" prepend-icon="event" persistent-hint
                                label="Fetch Data Till Date"></v-text-field>
                        </template>
                        <v-date-picker v-model="date1" no-title @input="menu1 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" md="2" sm="2">
                    <v-btn rounded class="button" @click="getAllReport()" :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="learner_info != ''" class="">
                <!-- <v-col sm="2">
                  <v-btn rounded  color="success" outlined @click="ExportToExcel();" :loading="loader"><v-icon   color="success">mdi-export</v-icon>Export</v-btn>
              </v-col> -->
                <v-row dense>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" rounded color="success" outlined @click="
                            fnExcelReport('my-table-id', 'installmentoutstandingreport')
                            " :loading="loader">
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="printReport()"> <v-icon
                                left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="showLogo()">
                            Hide /Show Logo
                        </v-btn>
                    </v-col>
                    <!-- <v-col cols="12" sm="3" md="3">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="showRemainingfeestudent()">
                           Show Only Remaining Fee Students
                        </v-btn>
                    </v-col> -->
                    <!-- search code shiv -->
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field class="ma-2 no-display" v-model="search" append-icon="mdi-magnify"
                            label="Search by Student name or by Registration Number" single-line
                            hide-details></v-text-field>
                    </v-col>
                </v-row>
                <div id="my-table-id">
                    <div class="scroll">
                        <!-- header code -->
                        <div v-if="org_basic_data">
                            <v-row dense justify="center">
                                <v-col cols="12" sm="4" md="2" v-if="org_basic_data.trust_logo && show_logo"
                                    align="center">
                                    <img :src="org_basic_data.trust_logo" alt="logo" class="trust-logo" />
                                </v-col>
                                <v-col cols="12" sm="4" md="8">
                                    <center>
                                        <h2>
                                            <strong>{{ org_basic_data.trust_name }}</strong>
                                        </h2>
                                        <h3>
                                            <strong>{{ org_basic_data.school_name }} </strong>
                                        </h3>
                                        <span>{{ org_basic_data.address }}</span> <br />
                                        <span>Phone :{{ org_basic_data.phone }} </span> <br />
                                        <span>Email :{{ org_basic_data.email }} </span> <br />
                                        <span>Website :{{ org_basic_data.website }} </span>
                                        <br />
                                    </center>
                                </v-col>
                                <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo && show_logo">
                                    <img :src="org_basic_data.school_logo" alt="logo" class="schl-logo" />
                                </v-col>
                            </v-row>
                        </div>
                        <div>
                            <center>
                                <b> <span>Installment Fees Due Report </span></b>
                            </center>
                        </div>
                        <!-- header end -->
                        <v-simple-table dense class="elevation-1" fixed-header>
                            <thead>
                                <tr>
                                    <th class="">Sr. No.</th>
                                    <th class="">Registration No.</th>
                                    <th class="">Name</th>
                                    <th class="">Mobile No.</th>
                                    <th class="">Quota</th>
                                    <th class="">Academic Year</th>
                                    <th class="">Admission Year</th>
                                    <th class="">Standard</th>
                                    <th class="">Division</th>
                                    <th class="" v-for="header in component_headers" :key="header">
                                        <center>{{ header }}</center>
                                    </th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <!-- <tr v-for="s in learner_info" :key="s.id"> -->
                                <tr v-for="(s,index) in filteredItems" :key="s.id">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ s.reg_no }}</td>
                                    <td>{{ s.name }}</td>
                                    <td>{{ s.primary_contact_number }}</td>
                                    <td>{{ s.quota }}</td>
                                    <td>{{ s.academicyear }}</td>
                                    <td>{{ s.learner_addmission_year }}</td>
                                    <td>{{ s.standard }}</td>
                                    <td>{{ s.div }}</td>
                                    <td v-for="(header, index) in s.all_comp" :key="index">
                                        <span v-if="header == 'Not Applicable'" class="text-color">
                                            {{ header }}
                                        </span>
                                        <span v-else>
                                            {{ header }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                            <tr>
                                <td colspan="9">
                                    <center><strong>Total</strong> </center>
                                </td>
                                <td>
                                    {{ overall_total_receivable }}
                                </td>
                                <td>
                                    {{ overall_concession }}
                                </td>
                                <td>
                                    {{ overall_actual_receivable }}
                                </td>
                                <td>
                                    {{ overall_paid }}
                                </td>
                                <td>
                                    {{ overall_remaining }}
                                </td>
                            </tr>
                        </v-simple-table>
                    </div>
                </div>
            </v-col>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data() {
        return {
            loader: false,
            // extraBreadcrumbItems: [


            // ],
            menu1: false,
            breadcrumbClass: "breadcrumb-style1",
            color: "",
            snackbar: false,
            search: "",
            snackbar_msg: null,
            fees_structure_data: null,
            current_academic_year: null,
            stream: null,
            div: [],
            std: [],
            header: null,
            academic_year_list: null,
            standard_list: null,
            dision_list: null,
            stream_list: null,
            header_list: null,
            show: false,
            learner_info: [],
            data_list: [],
            component_headers: [],
            all_total_amount: null,
            all_total_paid: null,
            all_total_remaining: null,
            status_list: [
                { name: "All", id: "3" },
                { name: "Active", id: "0" },
                { name: "Temporary Inactive", id: "1" },
                { name: "Permanent Inactive", id: "2" },
            ],
            status: null,
            org_basic_data: [],
            show_logo: true,
            show_balance_fee_student: false,
            show_date_wise: false,
            section_list: [],
            section: "",
            new_from_date: null,
            date1: new Date().toISOString().substr(0, 10),
            overall_remaining: null,
            overall_paid: null,
            overall_total_receivable: null,
            overall_concession: null,
            overall_actual_receivable: null,
        };
    },
    computed: {
        filteredItems() {
            return this.learner_info.filter((item) => {
                return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || item.reg_no.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
        },
    },
    watch: {
        date1(val) {
            this.new_from_date = this.formatDate(this.date1);
        },
    },
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table border='1px'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            //Save the file
            //   var blob = new Blob([tab_text], {
            //       type: "application/vnd.ms-excel;charset=utf-8",
            //   });
            //   window.saveAs(blob, fileName);
            const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const filename = name + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        showLogo() {
            if (this.show_logo) {
                this.show_logo = false;
            } else {
                this.show_logo = true;
            }
        },
        showRemainingfeestudent() {

        },
        printReport() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },
        ExportToExcel() {
            var htmltable = document.getElementById("my-table-id");
            var html = htmltable.outerHTML;
            window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
        },
        clear() {
            this.learner_info = [];
            this.data_list = [];
        },
        // clearselection() {
        //     (this.show = false), (this.learner_info = []);
        //     this.data_list = [];
        //     (this.standard_list = null), (this.std = null), (this.div = null), (this.dision_list = null);
        // },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [day, month, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        toggleDateFilter(){
            if(!this.show_date_wise){
                this.new_from_date = null
            }
        },
        getAllReport() {
            this.learner_info = []
            this.loader = true;
            this.search = "";
            if(this.show_date_wise && !this.new_from_date){
                this.loader = false;
                this.showSnackbar("#b71c1c","Please select date")
                return
            }
            if (this.show_date_wise) {
                const data = {
                    ay: this.current_academic_year.ay,
                    std: this.std,
                    div: this.div,
                    status: this.status,
                    section: this.section,
                    fromdate: this.new_from_date
                };
                axios
                    .post("/InstallmentStructureDetails/getInstallmentOutandingReport_DateWise", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            this.learner_info = res.data.learner_info;
                            this.component_headers = res.data.header_list;
                            this.org_basic_data = res.data.org_basic_data;
                            this.overall_remaining = res.data.overall_remaining
                            this.overall_paid = res.data.overall_paid
                            this.overall_total_receivable = res.data.overall_total_receivable;
                            this.overall_concession = res.data.overall_concession;
                            this.overall_actual_receivable = res.data.overall_actual_receivable;
                            if (this.show_balance_fee_student) {
                                this.learner_info = this.learner_info.filter(learner =>
                                    learner.all_comp !== "Not Applicable" && learner.all_comp[4] > 0
                                );
                            }
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            } else {
                const data = {
                    ay: this.current_academic_year.ay,
                    std: this.std,
                    div: this.div,
                    status: this.status,
                    section: this.section
                };
                axios
                    .post("/InstallmentStructureDetails/getInstallmentOutandingReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            this.learner_info = res.data.learner_info;
                            this.component_headers = res.data.header_list;
                            this.org_basic_data = res.data.org_basic_data;
                            this.overall_remaining = res.data.overall_remaining;
                            this.overall_paid = res.data.overall_paid;
                            this.overall_total_receivable = res.data.overall_total_receivable;
                            this.overall_concession = res.data.overall_concession;
                            this.overall_actual_receivable = res.data.overall_actual_receivable;
                            if (this.show_balance_fee_student) {
                                this.learner_info = this.learner_info.filter(learner =>
                                    learner.all_comp !== "Not Applicable" && learner.all_comp[4] > 0
                                );
                            }
                            if (res.data.flag == "YES" && this.learner_info.length === 0) {
                                this.showSnackbar("error", "No data found for selected filters");
                            }
                        }                         
                        else {
                            this.showSnackbar("#b71c1c", "Something went wrong...");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            }

        },
        // getStandard() {
        //     const data = {
        //         ay: this.current_academic_year.id,
        //         std: this.std,
        //     };
        //     axios
        //         .post("/InstallmentStructureDetails/getDivison", data)
        //         .then((res) => {
        //             if (res.data.flag == "YES") {
        //                 this.dision_list = res.data.dision_list;
        //             } else {
        //                 //error
        //             }
        //         })
        //         .catch((error) => {
        //             window.console.log(error);
        //         })
        //         .finally(() => {
        //             //close loader
        //         });
        // },
        getStandard() {
            this.standard_list = null,
                this.std = []
            const data = {
                ay: this.current_academic_year.id,
                section: this.section,
            };
            axios
                .post("/InstallmentStructureDetails/getSectionStandrd", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.standard_list = res.data.standard_list;
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onload() {
            axios
                .post("/InstallmentStructureDetails/getAllData")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.academic_year_list = res.data.ay_data;
                        this.current_academic_year = res.data.cay;
                        // this.standard_list = res.data.standardlist;
                        this.section_list = res.data.user_wise_section_list;
                        this.dision_list = res.data.division_list_All
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.get_ay_std_ft_loader = false;
                });
        },
    },
    mounted() {
        this.onload();
    },
};
</script>
<style scoped>
.text-color {
    font-weight: bold;
    color: red;
    font-size: small;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}

.dt-button {
    font-size: small;
    font-weight: bold;
}

.dt-button.buttons-print::before {
    content: "\F42A";
    margin-right: 8px;
    margin-top: 8px;
    font-size: small;
}

.dt-button.buttons-excel::before {
    content: "\F21B";
    margin-right: 8px;
    margin-top: 8px;
    font-size: small;
}

.dt-button.buttons-csv::before {
    content: "\FEC2";
    margin-right: 8px;
    margin-top: 8px;
    font-size: small;
}

button.dt-button:hover:not(.disabled),
div.dt-button:hover:not(.disabled),
a.dt-button:hover:not(.disabled) {
    border-color: #ff9800;
    color: #ff9800;
}

.dataTables_wrapper .dataTables_filter input[type="search"] {
    border-radius: 2px;
    border: 1px solid #cdcdcd;
    cursor: auto;
    white-space: nowrap !important;
}

@media print {

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    img {
        width: 100% !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .box {
        background-color: white !important;
        border: none !important;
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none;
        size: 20in 17in;
    }
}

.trust-logo {
    width: 86%;
}

.schl-logo {
    width: 86%;
}
</style>
